import styles from './GroupNavItem.scss';

import cx from 'classnames';
import React from 'react';
import { NavSubItem } from 'src/api/contentful/contentTypes.cloverdotcom';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';

import { GroupNavSubItem } from '../GroupNavSubItem/GroupNavSubItem';
import { NavListLinkProps } from '../NavListLink/NavListLink';

export interface GroupNavItemProps extends React.HTMLAttributes<HTMLLIElement>, Pick<NavListLinkProps, 'closeDrawer'> {
  entry?: FlatEntry<NavSubItem>;
}

export const GroupNavItem: React.FC<GroupNavItemProps> = ({
  entry,
  className,
  closeDrawer,
  ...props
}) => {
  if (!entry) return null;

  const subItemLinks = entry?.subItemLinks || [];
  if (!subItemLinks.length) return null;

  return (
    <li className={cx(styles.groupNavItem, className)} {...props}>
      <TextV2
        value={entry.title}
        tagName="h2"
        variant="eyebrow"
        entry={{ ...entry, field: 'title' }}
      />
      <ul className={styles.groupNavItemSubList}>
        {subItemLinks.map((item, index) => {
          return (
            <GroupNavSubItem
              key={componentKeyV2(item, index)}
              className={styles.groupNavItemSubItem}
              entry={item}
              closeDrawer={closeDrawer}
            />
          );
        })}
      </ul>
    </li>
  );
};

GroupNavItem.displayName = 'GroupNavItem';
